module.exports = __webpack_public_path__ + "static/media/illus.656cb525.svg";